import { memo, PropsWithChildren } from 'react';

import { Button, Text, useComponentStack } from '@/components/core';
import { ChevronIcon } from '@/components/icons';

type NewType = PropsWithChildren;

export type NavigationContainerProps = NewType;

const INavigationContainer = ({ children }: NavigationContainerProps) => {
  const componentStack = useComponentStack();

  return (
    <>
      <div className="border-b border-gray-200 p-2">
        <Button variant="plain" onPress={() => componentStack?.pop()}>
          <ChevronIcon rotation="left" />
          <Text>Back</Text>
        </Button>
      </div>

      <div className="grow">{children}</div>
    </>
  );
};

export const NavigationContainer = memo(INavigationContainer) as typeof INavigationContainer;
